import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import classnames from "classnames";
import moment from "moment";
import _ from "i18n";
import { getLabelsByLng } from "../../utils";

import {
  fetchPresentationEmailHistory,
  savePresentationEmailHistory,
  fetchPresentationAccessKey,
  sendPresentationEmail,
  fetchEmailTextModels,
  fetchEmailRecipients,
  fetchAssociationDashboard,
  saveAssociationDashboard
} from "Thunks";
import {
  setOrganizationSelectedItem,
  setSelectPrincipalDashboard
} from "actions";
import { onSuccess, onError } from "Utils";
import { MODEL_TEXT_EMAILING, TTP_DASHBOARD_URL } from "Config";

import { Tooltip } from "antd";
import { dateFormat } from "../../utils";
import { AttachmentIcon, CalendarIcon, ICONS, SvgIcon } from "../Common/Icons";
import ModalEmailling from "./ModalEmailling";
import styles from "./FicheClient.local.scss";
import { TTPReactModal } from "../Common/Modal/TTPReactModal";
import { ModalConfirm } from "tamtam-components";
import OrganizationDashboardFetching from "../OrganizationList/OrganizationDashboardFetching";
import CheckBox from "../OrganizationList/CheckBox";
import stylesButton from "../Common/Modal/Button.local.scss";
import { CHECKBOX_CHECKED, CHECKBOX_UNCHECKED } from "Config";
import { isClientAccess } from "Utils";

class ContentListPresentation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendingEmail: false,
      loadingEmailModels: false,
      loadingEmailHistory: false,
      loadingGeneratedUrls: false,
      loadingEmailRecipients: false,
      emailsData: [],
      emailTextModels: [],
      loadingIframe: false,
      error: null,
      history: {},
      recipients: [],
      isEmailModalVisible: false,
      showAssociationModal: false,
      dashboardId: null,
      disabled: true
    };
  }

  componentDidMount() {
    const { lng, organizationUen } = this.props;
    this.setState({
      loadingEmailModels: true,
      loadingGeneratedUrls: true,
      loadingEmailRecipients: true
    });
    this.props
      .dispatch(fetchEmailTextModels(lng))
      .then(res => {
        let contents = res.value.data.data.map(t => {
          return {
            type: t.targetType,
            content: t.content
          };
        });
        this.setState({
          emailTextModels: contents,
          loadingEmailModels: false
        });
      })
      .catch(er => {
        this.setState({
          error: 120000,
          loadingEmailModels: false
        });
      });
    this.props
      .dispatch(fetchPresentationAccessKey(organizationUen, "ALL"))
      .then(res => {
        let contents = res.value.map(t => {
          return {
            expires: t.expires,
            period: t.period,
            target: t.target,
            key: t.key
          };
        });
        this.setState({
          generatedURLs: contents,
          loadingGeneratedUrls: false
        });
      })
      .catch(er => {
        this.setState({
          error: er.response.data.statusCode,
          loadingGeneratedUrls: false
        });
      });
    this.props
      .dispatch(fetchEmailRecipients(organizationUen))
      .then(res => {
        let recipients = res.value.data.data;
        this.setState({
          recipients,
          loadingEmailRecipients: false
        });
      })
      .catch(er => {
        this.setState({
          error:
            er.response &&
            er.response.data.errors &&
            er.response.data.errors[0].code,
          loadingEmailRecipients: false
        });
      });
  }
  prepareDataEmailContentModal(year, item) {
    let { emailTextModels, generatedURLs } = this.state;
    const { organization } = this.props;

    let generatedURLData = generatedURLs.filter(url => {
      return url.period === year + "";
    });
    let generatedUrl = generatedURLData.length
      ? TTP_DASHBOARD_URL +
        "/presentation/" +
        generatedURLData[0].target +
        "?year=" +
        year +
        "&&access_key=" +
        generatedURLData[0].key
      : null;

    let emailsDataArray = emailTextModels.map(model => {
      let disabled =
        (model.type === "APPOINTMENT" && item && !item.date) ||
        (model.type === "GENERATED_LINK" && !generatedURLData.length)
          ? true
          : false;
      return {
        modelCode: model.type,
        disabled: disabled,
        modelType: _(MODEL_TEXT_EMAILING[model.type].title),
        clientName: organization.organization.name,
        datePresentation: item && item.date ? item.date : null,
        textButton: _(MODEL_TEXT_EMAILING[model.type].action),
        description: model.content,
        state: item && item.isPrepared ? "prepared" : "notPrepared",
        url: generatedUrl,
        expires: generatedURLData.length && generatedURLData[0].expires,
        year
      };
    });
    this.setState({
      emailsData: emailsDataArray
    });
  }

  handlePlayPresentation(year) {
    const { dispatch, organizationUen } = this.props;
    dispatch(push("/diaporama/" + organizationUen + "?year=" + year));
  }

  handlePreparePresentation(year) {
    const { dispatch, organizationUen } = this.props;
    dispatch(
      push("/prepare-presentation/" + organizationUen + "?year=" + year)
    );
  }

  handleOpenEmailModal = (year, data) => {
    const { organizationUen } = this.props;
    let {
      loadingEmailModels,
      loadingEmailRecipients,
      loadingGeneratedUrls,
      error
    } = this.state;
    if (loadingEmailModels || loadingEmailRecipients || loadingGeneratedUrls) {
      return;
    }
    if (!error) {
      let item = data && data.filter(item => item.period === year + "")[0];
      this.setState({ loadingEmailHistory: true });
      this.props
        .dispatch(fetchPresentationEmailHistory(organizationUen, year))
        .then(res => {
          let newHistory = this.prepareHistoryMap(res.value.data.data, {});
          this.prepareDataEmailContentModal(year, item);
          this.setState({ loadingEmailHistory: false, history: newHistory });
        })
        .catch(er => {
          this.setState({
            error: er.response.data.errors && er.response.data.errors[0].code,
            loadingEmailHistory: false
          });
        });
    }

    this.setState({
      isEmailModalVisible: true
    });
  };

  prepareHistoryMap = (histories, history) => {
    let result = history;
    histories.forEach(item => {
      if (!result[item.model]) {
        result[item.model] = [
          { date: item.sentThe, recipient: item.recipient }
        ];
      } else {
        result[item.model].unshift({
          date: item.sentThe,
          recipient: item.recipient
        });
      }
    });
    return result;
  };

  handleSendEmail = (
    recipients,
    modelCode,
    data,
    emails,
    events,
    organization
  ) => {
    const { lng } = this.props;
    this.setState({
      sendingEmail: true
    });
    let icsContent = this.createICS(events, organization, emails).join("\n");
    let file = new File(
      [icsContent],
      `Calendar-${moment().format("YYYY-MM-DD-HH:MM:SS")}.ics`,
      {
        type: "text/calendar;charset=utf-8"
      }
    );

    this.props
      .dispatch(sendPresentationEmail(recipients, modelCode, lng, data, [file]))
      .then(res => {
        this.handleSavePresentationMailHistory(modelCode, data, emails);
      })
      .catch(err => {
        onError(err.response.data.errors[0].message);
        this.setState({
          sendingEmail: false
        });
      });
  };

  createICS = (events, organization, recipients) => {
    const { user } = this.props;
    let icsCalEvents = [];
    let calName = `invite.ics`;
    let endDate =
      moment(events.datePresentation).format("YYYYMMDD") +
      "T" +
      moment(events.datePresentation)
        .add(0.3, "hours")
        .format("HHMMSS") +
      "Z";
    recipients.map(recipient => {
      icsCalEvents = [
        ...icsCalEvents,
        "ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=NEEDS-ACTION;RSVP=\n" +
          " TRUE;CN=" +
          recipient +
          ":mailto:" +
          recipient
      ];
    });

    return [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//pro.tamtam.cal//NONSGML v1.0//EN",
      "METHOD:REQUEST",
      "CALSCALE:GREGORIAN",
      `NAME:${calName}`,
      `X-WR-CALNAME:${calName}`,
      "BEGIN:VEVENT",
      `UID:${organization}@tamtam.pro`,
      `DTSTART:${this.formatTime(events.datePresentation)}`,
      `DTSTAMP:${endDate}`,
      `DTEND:${endDate}`,
      `SUMMARY:Présentation de ${organization}`,
      `DESCRIPTION:Présentation de ${organization}`,
      `LOCATION:${"Belgique/Maroc"}`,
      "SUMMARY:Presentation de Client " + organization,
      "ORGANIZER;CN=" + user.mainEmail + ":mailto:" + user.mainEmail,
      ...icsCalEvents,
      "ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=NEEDS-ACTION;RSVP=\n" +
        " TRUE;CN=" +
        user.mainEmail +
        ":mailto:" +
        user.mainEmail,
      "ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=NEEDS-ACTION;RSVP=\n" +
        " TRUE;CN=" +
        "qc.tamtam@gmail.com" +
        ":mailto:" +
        "qc.tamtam@gmail.com",
      "END:VEVENT",
      "END:VCALENDAR"
    ];
  };
  formatTime = date => {
    const formattedDate = moment(date)
      .utc()
      .format("YYYYMMDDTHHmmssZ");
    return formattedDate.replace("+00:00", "Z");
  };

  handleSavePresentationMailHistory = (modelCode, data, emails) => {
    const { organizationUen } = this.props;
    let { history } = this.state;
    this.setState({ sendingEmail: true });
    this.props
      .dispatch(
        savePresentationEmailHistory(
          organizationUen,
          emails,
          modelCode,
          data["{{PRESENTATION.YEAR}}"]
        )
      )
      .then(res => {
        onSuccess(res, {
          title: _("sendSuccess"),
          body: _("mailSent")
        });
        let element = [
          {
            model: modelCode,
            recipient: "[".concat("", emails.join(",")).concat("", "]"),
            sentThe: moment().format("YYYY-MM-DD HH:mm")
          }
        ];
        let newHistory = this.prepareHistoryMap(element, history);
        this.setState({ sendingEmail: false, history: newHistory });
      })
      .catch(err => {
        onError(err.response.data.errors[0].message);
        this.setState({
          sendingEmail: false
        });
      });
  };

  closeModal = () => {
    this.setState({ isEmailModalVisible: false });
  };
  showAssociationModal = () => {
    this.setState({
      showAssociationModal: true,
      dashboardId: null,
      disabled: true
    });
    this.props.dispatch(
      setOrganizationSelectedItem([this.props.organization.id])
    );
    this.props.dispatch(fetchAssociationDashboard());
  };

  handleCancelAssociationModal = () => {
    const { disabled } = this.state;
    if (!disabled) {
      this.setState({ isOpenModal: true });
    } else {
      this.setState({ showAssociationModal: false });
    }
  };

  renderModalFooterAssociateDashboard = () => {
    return [
      <button
        key="back"
        className={stylesButton.back}
        onClick={this.handleCancelAssociationModal}
      >
        {_("cancel")}
      </button>,
      <button
        key="submit"
        type="primary"
        className={stylesButton.save}
        onClick={this.handleSubmitAssociationModal}
        disabled={this.state.disabled}
      >
        {this.state.loading && (
          <img
            src={"/img/icons/tail-spin.svg"}
            alt={""}
            className={stylesButton.loading}
          />
        )}
        {_("save")}
      </button>
    ];
  };

  handleSelectPrincipalDashboard = dashboardId => {
    const { associationDashboard } = this.props;
    this.setState({ dashboardId: dashboardId, disabled: false });
    this.props.dispatch(
      setOrganizationSelectedItem(this.props.organization.id)
    );
    let newAssociationDashboard = [...associationDashboard];
    let newSelection = newAssociationDashboard.map(element => {
      if (element.id === dashboardId) {
        if (element.state !== CHECKBOX_CHECKED) {
          element.state = CHECKBOX_CHECKED;
        } else {
          this.setState({ dashboardId: null });
          element.state = CHECKBOX_UNCHECKED;
        }
      } else {
        element.state = CHECKBOX_UNCHECKED;
      }
      return element;
    });
    this.props.dispatch(setSelectPrincipalDashboard(newSelection));
  };
  handleSubmitAssociationModal = () => {
    const { selectedYear } = this.props;
    const { dashboardId, disabled } = this.state;
    if (disabled) {
      return;
    }
    this.setState({ loading: true });
    this.props.dispatch(saveAssociationDashboard({ dashboardId })).then(
      res => {
        this.setState({
          loading: false,
          showAssociationModal: false
        });
        onSuccess(res, {
          body: _("updateAssociationSuccess"),
          title: _("saveSuccess")
        });
        //this.props.dispatch(fetchOrganizations(this.props.synchro));
        this.props.dispatch(
          push(`/fiche-client/${this.props.organizationUen}/${selectedYear}`)
        );
      },
      err => {
        this.setState({ loading: false, showAssociationModal: false });
        onError(err.response.data.errors[0].message);
      }
    );
  };

  isHavingAnnexes = (annexes, year) => {
    return (
      <span>
        {Array.isArray(annexes) &&
        annexes.filter(item => item.year === year)[0] ? (
          <span className={classnames(styles.header_title, styles.labels)}>
            {_("withAnnexe")}
          </span>
        ) : (
          <span className={classnames(styles.header_title, styles.labels)}>
            {_("noAnnexes")}
          </span>
        )}
      </span>
    );
  };

  handleDisplayEditSendActions = (year, data) => {
    let {
      loadingEmailModels,
      loadingEmailRecipients,
      loadingGeneratedUrls
    } = this.state;
    let { currentOrganization, portail } = this.props;
    return (!isClientAccess(currentOrganization, portail) && (
      <div style={{ display: "flex" }}>
        <div className={styles.item_actions}>
          <Tooltip placement="bottom" title={_("prepare")} mouseLeaveDelay={0}>
            <div
              className={classnames(
                styles.presentations_actions,
                styles.prepare_presentation_action
              )}
              onClick={() => {
                this.handlePreparePresentation(year);
              }}
            >
              <SvgIcon icon={ICONS.PENCIL} className={""} />
            </div>
          </Tooltip>
        </div>
        <div className={styles.item_actions}>
          <Tooltip placement="bottom" title={_("send")} mouseLeaveDelay={0}>
            <div
              className={classnames(
                styles.presentations_actions,
                styles.prepare_presentation_action,
                loadingEmailModels ||
                loadingEmailRecipients ||
                loadingGeneratedUrls
                  ? styles.prepare_presentation_action_disabled
                  : ""
              )}
              onClick={() => {
                this.handleOpenEmailModal(year, data);
              }}
            >
              <SvgIcon icon={ICONS.SEND} className={""} />
            </div>
          </Tooltip>
        </div>
      </div>
    ): "");
  };

  handle_firstDisplayActions = (year, data) => {
    return (
      <div style={{ display: "flex" }}>
        <div>
          <div className={styles.play}>
            <Tooltip placement="bottom" title={_("play")} mouseLeaveDelay={0}>
              <div
                className={classnames(
                  styles.presentations_actions,
                  styles.play_action
                )}
                onClick={() => {
                  this.handlePlayPresentation(year, data);
                }}
              >
                <SvgIcon
                  icon={ICONS.DIAPORAMA}
                  className={styles.center_play_butt}
                />
                <span className={styles.play_title}>{_("play")}</span>
              </div>
            </Tooltip>
          </div>
        </div>
        {this.handleDisplayEditSendActions(year, data)}
      </div>
    );
  };

  handleDisplayActions = (year, data) => {
    return (
      <div style={{ display: "flex" }}>
        <div className={styles.item_actions}>
          <Tooltip placement="bottom" title={_("play")} mouseLeaveDelay={0}>
            <div
              className={classnames(
                styles.presentations_actions,
                styles.play_action
              )}
              style={{ fill: "white !important" }}
              onClick={() => {
                this.handlePlayPresentation(year);
              }}
            >
              <SvgIcon
                icon={ICONS.DIAPORAMA}
                className={styles.center_play_butt}
                style={{ fill: "white !important" }}
              />
            </div>
          </Tooltip>
        </div>
        {this.handleDisplayEditSendActions(year, data)}
      </div>
    );
  };

  handleRedirectFolderSetting = () => {
    const { organizationUen } = this.props;
    const { appsState } = this.props;
    let directoryConfig =
      appsState && appsState.filter(app => app.code === "directory")[0];

    window.open(
      `${directoryConfig.url}/folders/${organizationUen}/edit`,
      "_blank"
    );
  };

  handleRedirectEmailingSetting = () => {
    const { appsState } = this.props;
    let emailingConfig =
      appsState && appsState.filter(app => app.code === "emailing")[0];

    window.open(`${emailingConfig.url}/templates`, "_blank");
  };

  render() {
    const {
      lng,
      data,
      annexes,
      organization,
      accountingDates,
      organizationModel,
      associationDashboard,
      fetching,
      currentOrganization,
      fetched,
      selectedYear,
      portail
    } = this.props;
    let {
      error,
      history,
      recipients,
      emailsData,
      sendingEmail,
      loadingEmailHistory,
      isOpenModal
    } = this.state;
    return (
      <div>
        <div className={styles.presentation_title}>
          {_("presentations")} ({accountingDates && accountingDates.length})
        </div>
        {organizationModel && (
          <div className={styles.model_affected}>
            <div className={styles.model_affected_details}>
              <div>
                {_("affectedModel")}
                <span className={styles.organisation_model}>
                  {getLabelsByLng(JSON.parse(organizationModel), lng)}
                </span>
              </div>
              {!isClientAccess(currentOrganization, portail) && (
                <span onClick={this.showAssociationModal}>
                  <span className={styles.modifierLinkModal}>{_("edit")}</span>
                </span>
              )}
            </div>
            {organization.dashboardAssociation && (
              <div>
                <SvgIcon icon={ICONS.ALERT_CIRCLE} />
                {_(`${organization.dashboardAssociation}AssociationMessage`)}
              </div>
            )}
          </div>
        )}
        <TTPReactModal
          title={_("associateClientTitle")}
          isOpen={this.state.showAssociationModal}
          inProcess={false}
          onConfirm={this.handleOk}
          onCancel={this.handleCancelAssociationModal}
          footer={this.renderModalFooterAssociateDashboard()}
          associateModal={true}
        >
          <ModalConfirm
            type={"return"}
            isOpen={isOpenModal}
            onCancel={() => this.setState({ isOpenModal: false })}
            onConfirm={() => {
              this.setState({ showAssociationModal: false });
              this.setState({ isOpenModal: false });
            }}
            inProcess={false}
            actionFailed={false}
            title={_("cancelConfirm")}
            text={_("cancelConfirmContent")}
            labelNo={_("cancel")}
            labelYes={_("exit")}
            labelError={"Error"}
          />
          <div>
            <div
              className={classnames(
                styles.description,
                styles.title_client_list
              )}
            >
              {_("clientsList")}:
            </div>
            <div className={styles.div_elements}>
              <div className={classnames(styles.element, styles.client)}>
                {organization && organization.organization.name}
              </div>
            </div>
            <div className={styles.description}>{_("dashboardPrincipal")}:</div>
            <div
              className={classnames(
                styles.div_elements,
                styles.dashboard_principal
              )}
            >
              {fetching && <OrganizationDashboardFetching />}
              {fetched &&
                associationDashboard.map((dashboard, i) => {
                  return (
                    <div
                      key={i}
                      className={styles.element + " " + styles.element_dasboard}
                    >
                      <CheckBox
                        state={dashboard.state}
                        handleSelectCheckbox={() =>
                          this.handleSelectPrincipalDashboard(dashboard.id)
                        }
                      />
                      <span
                        className={
                          dashboard.name.length > 25 && styles.dashbord_name
                        }
                      >
                        {getLabelsByLng(JSON.parse(dashboard.name), lng)}
                      </span>
                    </div>
                  );
                })}
            </div>
          </div>
        </TTPReactModal>
        {accountingDates &&
          accountingDates.map((accountingDate, k) => {
            return (
              <div className={styles.created_date} key={k}>
                {Array.isArray(data) &&
                  data.filter(
                    item => item.period === accountingDate.year + ""
                  )[0] && (
                    <span>
                      {_("createdAt")}{" "}
                      {dateFormat(
                        data.filter(
                          item => item.period === accountingDate.year + ""
                        )[0].createdAt,
                        lng
                      )}
                    </span>
                  )}
                {accountingDate.year === selectedYear ||
                accountingDate.year + "" === selectedYear ? (
                  <div
                    className={`row ${styles.presentation_items} border-${
                      Array.isArray(data) &&
                      data.filter(
                        item => item.period === accountingDate.year + ""
                      )[0] &&
                      data.filter(
                        item => item.period === accountingDate.year + ""
                      )[0].isPrepared
                        ? "success"
                        : "alert"
                    }`}
                    style={{ height: "248px" }}
                  >
                    {Array.isArray(data) &&
                    data.filter(
                      item => item.period === accountingDate.year + ""
                    ).length < 1 ? (
                      <div className={classnames(styles.items)}>
                        <div
                          className={classnames(
                            styles.presentation_first_background
                          )}
                        >
                          <div className={styles.presentation_items_info}>
                            <div className={styles.title}>
                              {_("presentation")} {selectedYear}
                            </div>
                            <div>
                              <i className={`bg-alert`} />
                              <span className={styles.alert}>
                                {_("notPrepared")}
                              </span>
                            </div>
                            <div className={styles.presentation_item}>
                              <CalendarIcon fill={"#ffffff"} size={12} />
                              <span
                                className={classnames(
                                  styles.header_title,
                                  styles.labels
                                )}
                              >
                                {_("undefinedDate")}
                              </span>
                            </div>
                            <div className={styles.actions_button}>
                              <AttachmentIcon fill={"#ffffff"} size={12} />
                              {this.isHavingAnnexes(
                                annexes,
                                accountingDate.year
                              )}
                            </div>
                            <div className={styles.presentation_items_status}>
                              {this.handle_firstDisplayActions(
                                selectedYear,
                                data
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className={classnames(styles.items)}>
                        <div
                          className={classnames(
                            styles.presentation_first_background
                          )}
                        >
                          <div className={styles.presentation_items_info}>
                            <div className={styles.title}>
                              {_("presentation")} {selectedYear}
                            </div>
                            <div>
                              {Array.isArray(data) &&
                              data.filter(
                                item => item.period === accountingDate.year + ""
                              )[0].isPrepared ? (
                                <div>
                                  <i className={`bg-success`} />
                                  <span className={styles.success}>
                                    {_("prepared")}
                                  </span>
                                </div>
                              ) : (
                                <div>
                                  <i className={`bg-alert`} />
                                  <span className={styles.alert}>
                                    {_("notPrepared")}
                                  </span>
                                </div>
                              )}
                            </div>
                            <div>
                              <CalendarIcon fill={"#ffffff"} size={12} />
                              {Array.isArray(data) &&
                              data.filter(
                                item => item.period === accountingDate.year + ""
                              )[0].date ? (
                                <span
                                  className={classnames(
                                    styles.header_title,
                                    styles.labels
                                  )}
                                >
                                  {_("toPresenteThe")}{" "}
                                  <b>
                                    {moment(
                                      data.filter(
                                        item =>
                                          item.period ===
                                          accountingDate.year + ""
                                      )[0].date
                                    ).format("YYYY-MM-DD HH:mm")}
                                  </b>
                                </span>
                              ) : (
                                <span
                                  className={classnames(
                                    styles.header_title,
                                    styles.labels
                                  )}
                                >
                                  {_("undefinedDate")}
                                </span>
                              )}
                            </div>
                            <div className={styles.actions_button}>
                              <AttachmentIcon fill={"#ffffff"} size={12} />
                              {this.isHavingAnnexes(
                                annexes,
                                accountingDate.year
                              )}
                            </div>
                            <div className={styles.presentation_items_status}>
                              {this.handle_firstDisplayActions(
                                accountingDate.year,
                                data
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className={`row ${styles.presentation_items} border-${
                      Array.isArray(data) &&
                      data.filter(
                        item => item.period === accountingDate.year + ""
                      )[0] &&
                      data.filter(
                        item => item.period === accountingDate.year + ""
                      )[0].isPrepared
                        ? "success"
                        : "alert"
                    }`}
                  >
                    {Array.isArray(data) &&
                    data.filter(
                      item => item.period === accountingDate.year + ""
                    ).length < 1 ? (
                      <div className={classnames(styles.items)}>
                        <div
                          className={classnames(
                            styles.presentation_background,
                            "medium-3"
                          )}
                        >
                          <div className={styles.title}>
                            <span>
                              {_("presentation")} {accountingDate.year}
                            </span>
                          </div>
                        </div>
                        <div className={styles.presentation_items_info}>
                          <div className={styles.presentation_items_text}>
                            {_("presentation")} {accountingDate.year}
                          </div>
                          <div>
                            <i className={`bg-alert`} />
                            <span className={styles.alert}>
                              {_("notPrepared")}
                            </span>
                          </div>
                          <div>
                            <CalendarIcon fill={"#6D7F92"} size={12} />
                            <span className={styles.labels}>
                              {_("undefinedDate")}
                            </span>
                          </div>
                          <div>
                            <AttachmentIcon fill={"#6D7F92"} size={12} />
                            {this.isHavingAnnexes(annexes, accountingDate.year)}
                          </div>
                        </div>

                        <div className={styles.presentation_items_status}>
                          {this.handleDisplayActions(accountingDate.year, data)}
                        </div>
                      </div>
                    ) : (
                      <div className={classnames(styles.items)}>
                        <div
                          className={classnames(
                            styles.presentation_background,
                            "medium-3"
                          )}
                        >
                          <div className={styles.title}>
                            <span>
                              {_("presentation")} {accountingDate.year}
                            </span>
                          </div>
                        </div>
                        <div className={styles.presentation_items_info}>
                          <div className={styles.presentation_items_text}>
                            {_("presentation")} {accountingDate.year}
                          </div>
                          <div>
                            {Array.isArray(data) &&
                            data.filter(
                              item => item.period === accountingDate.year + ""
                            )[0].isPrepared ? (
                              <div>
                                <i className={`bg-success`} />
                                <span className={styles.success}>
                                  {_("prepared")}
                                </span>
                              </div>
                            ) : (
                              <div>
                                <i className={`bg-alert`} />
                                <span className={styles.alert}>
                                  {_("notPrepared")}
                                </span>
                              </div>
                            )}
                          </div>

                          <div>
                            <CalendarIcon fill={"#6D7F92"} size={12} />
                            {Array.isArray(data) &&
                            data.filter(
                              item => item.period === accountingDate.year + ""
                            )[0].date ? (
                              <span className={styles.labels}>
                                {_("toPresenteThe")}{" "}
                                <b>
                                  {moment(
                                    data.filter(
                                      item =>
                                        item.period === accountingDate.year + ""
                                    )[0].date
                                  ).format("YYYY-MM-DD HH:mm")}
                                </b>
                              </span>
                            ) : (
                              <span className={styles.labels}>
                                {_("undefinedDate")}
                              </span>
                            )}
                          </div>
                          <div>
                            <AttachmentIcon fill={"#6D7F92"} size={12} />
                            {this.isHavingAnnexes(annexes, accountingDate.year)}
                          </div>
                        </div>
                        <div className={styles.presentation_items_status}>
                          {this.handleDisplayActions(accountingDate.year, data)}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        <ModalEmailling
          isVisible={this.state.isEmailModalVisible}
          onSendEmail={this.handleSendEmail}
          modelEmailing={emailsData}
          recipients={recipients}
          isClose={this.closeModal}
          error={error}
          lng={lng}
          history={history}
          sending={sendingEmail}
          fetching={loadingEmailHistory}
          onRedirectHome={this.handleRedirectFolderSetting}
          onRedirectEmailing={this.handleRedirectEmailingSetting}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  organizations: state.organizations.list.items,
  fetched: state.organizations.associationDashboard.fetched,
  associationDashboard: state.organizations.associationDashboard.data,
  fetching: state.organizations.associationDashboard.fetching,
  currentOrganization: state.auth.currentOrganization,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro,
  appsState:
    state.auth.currentOrganization && state.auth.currentOrganization.appsState,
  user: state.auth.user,
  portail: state.auth.portail
});

export default connect(mapStateToProps)(ContentListPresentation);



// WEBPACK FOOTER //
// ./src/components/FicheClient/ContentListPresentation.js